import type { ButtonGroupOption } from '/react4xp/components/react-hook-form/ButtonGroup';
import type { Phrases } from '../Phrases.d';

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
// import { ButtonGroup } from '../../../../components/react-hook-form/ButtonGroup';
import { ButtonCheckboxGroup } from '/react4xp/components/react-hook-form/buttonCheckboxGroup/ButtonCheckboxGroup';
import {
	type SubstanceForm,
	COMMON_FIELD_NAME,
	SUBSTANCE_FORM,
} from '../constants';


export const CapsulePowderColorButtonGroup = ({
	capsulePowderColorOptions,
	phrases,
	...otherProps
}: {
	capsulePowderColorOptions: ButtonGroupOption[];
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();
	const substanceForm: SubstanceForm = useWatch({ control, name: COMMON_FIELD_NAME.SUBSTANCE_FORM}) as SubstanceForm;
	return (
		<ButtonCheckboxGroup
			{...otherProps}
			className='z-0'
			description={phrases['notificationForm.term.chooseOneOrMore']}
			// multiple
			name={COMMON_FIELD_NAME.CAPSULE_POWDER_COLOR}
			options={capsulePowderColorOptions}
			showIf={({ watch }) => substanceForm === SUBSTANCE_FORM.CAPSULE}
		/>
	);
};
